import React from 'react';
import { observer } from 'mobx-react';
import { AppUI, ExerciseUI } from '@seedlang/state';
import { isBlank, isPresent } from '@seedlang/utils';
import Spinner from 'components/spinner';
import styled from '@emotion/styled';
import YoutubePlayer from 'components/worksheet/youtube_player';
import PodcastPlayer from 'components/worksheet/podcast_player';
import WorksheetDescription from 'components/worksheet/worksheet_description';
import { observable, computed } from 'mobx';

const TopSection = styled.div`
  display: flex;
  @media (max-width: 999px) {
    flex-direction: column;
  }
  gap: 10px;
`;

const MediaSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  visibility: ${props => props.visibility};
`;

@observer
class WorksheetInfo extends React.Component {
  @observable showModal = false;

  @computed get showYoutubeVideo() {
    // in ios safari the iframe will always be on top of the modal
    return !(AppUI.layout.ios && AppUI.layout.isSafari && this.showModal);
  }

  render() {
    return (
      <TopSection>
          {
            !ExerciseUI.hasWorksheet &&
            <Spinner
              background={AppUI.site.accentColor || '#868686'}
            />
          }
          {
            ExerciseUI.hasWorksheet &&
              <WorksheetDescription
                namespace={this.props.params.namespace}
                borderRadius={this.props.borderRadius}
                showModal={this.showModal}
                onModalChange={show => this.showModal = show}
              />
          }
          {
            !AppUI.layout.isMobile && ExerciseUI.hasWorksheet && isPresent(ExerciseUI.worksheet.podcastEpisode) && isBlank(ExerciseUI.formattedYoutubeUrl) &&
            <MediaSection>
              <PodcastPlayer
                hasAccess={ExerciseUI.hasCurrentWorksheetAccess}
                podcast={ExerciseUI.worksheet.podcastEpisode.podcast}
                podcastEpisode={ExerciseUI.worksheet.podcastEpisode}
                borderRadius={this.props.borderRadius}
              />
            </MediaSection>
          }
          {
            ExerciseUI.hasWorksheet && isPresent(ExerciseUI.formattedYoutubeUrl) &&
            <MediaSection id='video-player' visibility={this.showYoutubeVideo ? 'visible' : 'hidden'}>
              <YoutubePlayer
                allowFloating={!ExerciseUI.exercise?.formattedDescriptionVideo}
                hasAccess={ExerciseUI.hasCurrentWorksheetAccess}
                url={ExerciseUI.formattedYoutubeUrl}
                placeholderImageUrl={ExerciseUI.worksheet?.image?.url}
                podcastEpisode={ExerciseUI.worksheet.podcastEpisode}
                borderRadius={this.props.borderRadius}
              />
            </MediaSection>
          }
        </TopSection>
    );
  }
}

export default WorksheetInfo;
